import { render } from "./AcquisitionUpdate.vue?vue&type=template&id=34b43c5b&scoped=true"
import script from "./AcquisitionUpdate.vue?vue&type=script&lang=js"
export * from "./AcquisitionUpdate.vue?vue&type=script&lang=js"

import "./AcquisitionUpdate.vue?vue&type=style&index=0&id=34b43c5b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34b43c5b"]])

export default __exports__